import React from 'react'
import Cta from 'core/styles/Cta'
import Link from 'next/link'
import Grid, { Cell } from 'core/styles/Grid'
import { Container } from 'core/styles/Container'
import { MainCard } from 'core/components/Card'
import styled from 'styled-components'
import { breakpoint } from '../layout/styles'

const FeaturedRecipe = ({ recipe, translations }: any) => {
  // Guard against missing filter/url_token to prevent <Link href="/recipes/undefined/undefined">
  // which causes Next.js to prefetch a nonsensical _next/data URL.
  const filterValue = recipe.filters?.[0]?.value
  const recipeLink = filterValue && recipe.url_token
    ? `/recipes/${filterValue}/${recipe.url_token}`
    : '/recipes'

  return (
  <Container style={{ margin: '0 auto 48px' }}>
    <FeaturedCard>
      <FeaturedGrid style={{ width: '100%' }}>
        <FeaturedContent md={3}>
          <div>
            <h2 style={{ fontSize: '26px', lineHeight: 1.3 }}>{recipe.title}</h2>
            <p>{recipe.featured_settings?.description}</p>
            <Link href={recipeLink} passHref>
              <Cta href="" forceLight={true} style={{ display: 'inline-block' }}>{translations?.recipe_cta}</Cta>
            </Link>
          </div>
        </FeaturedContent>
        <FeaturedImage md={9} style={{
          background: `url('${recipe.images?.[0].url}?width=770&auto=webp&format=pjpg&quality=75') no-repeat scroll center center`,
          backgroundSize: 'cover'
        }} />
      </FeaturedGrid>
    </FeaturedCard>
  </Container>
  )
}

export default FeaturedRecipe

export const FeaturedContent = styled(Cell)`
 flex: 3.5;
 padding: 50px;
 display: flex;
 flex-direction: column;
 justify-content: center;
`

export const FeaturedImage = styled(Cell)`
  height: 268px;
  @media ${breakpoint.desktop} {
    height: 440px;
  }
`
const FeaturedGrid = styled(Grid)`
  flex-direction: column-reverse;
  @media ${breakpoint.desktop} {
    flex-direction: row;
  }
`

export const FeaturedCard = styled(MainCard)`
  &&& {
    margin-top: 0;
    padding: 0;
    width: 100%;
    background: var(--primary);
    color: #fff;
    height: auto;
    @media ${breakpoint.desktop} {
      height: 440px;
    }
  }
`